import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Badge, Fab, Tooltip } from '@mui/material';
import { getActiveRecipes } from '../utils/cookSession';

const CookingFab = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [count, setCount] = useState(0);

    useEffect(() => {
        const update = () => setCount(getActiveRecipes().length);
        update();
        window.addEventListener('cookSessionChanged', update);
        return () => window.removeEventListener('cookSessionChanged', update);
    }, []);

    if (count === 0 || location.pathname === '/cook') return null;

    return (
        <Tooltip title="Cooking session" placement="left">
            <Fab
                onClick={() => navigate('/cook')}
                sx={{
                    position: 'fixed',
                    bottom: { xs: 80, md: 32 },
                    right: 24,
                    zIndex: 1300,
                    bgcolor: 'primary.main',
                    color: '#fff',
                    fontSize: '1.4rem',
                    '&:hover': { bgcolor: 'primary.dark' },
                }}
            >
                <Badge badgeContent={count} color="error" sx={{ '& .MuiBadge-badge': { top: -4, right: -4 } }}>
                    🍳
                </Badge>
            </Fab>
        </Tooltip>
    );
};

export default CookingFab;
